import styled from 'styled-components';
import Grid from '../../Utility/Grid/Grid';
import { mixins } from '../../css';
import SVGIcon from '../../SVGIcon/SVGIcon';

export const StyledInternalGrid = styled(Grid.Container)`
  padding-top: ${mixins.pxToRem(50)};
`;

export const StyledIcon = styled(SVGIcon)`
  display: inline-block;
  vertical-align: middle;
  margin-left: ${mixins.pxToRem(8)};
`;
